import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button, ListGroup, Spinner, Form, InputGroup } from 'react-bootstrap';
import { postLoteLab, getPlantillasProcedimiento } from '../../../api/common';
import { useAuth } from '../../../hooks/useAuth';

// Modal para crear lote de calibración a partir de equipos seleccionados
const LoteCreateModal = ({ show, onHide, selectedIds = [], selectedEquipos = [], onCreated, responsable }) => {
  const [creating, setCreating] = useState(false);
  const { userData } = useAuth();

  const handleCreate = async () => {

    setCreating(true);
    try {
      const payload = {
        equipos: selectedIds,
        responsable: responsable || userData?._id,
        estado: 'pendiente',
      };
      await postLoteLab(payload);
      if (onCreated) onCreated();
    } catch (err) {
      console.error(err);
      alert(err?.message || 'Error creando lote');
    } finally {
      setCreating(false);
    }
  };

  return (
    <Modal 
      show={show} onHide={onHide} size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Crear Lote de Calibración</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{maxHeight:'75vh', overflowY:'auto'}}
      >
        <p>Responsable: <strong>{userData?.nombre} {userData?.apellido} </strong></p>
        <p className="mt-3">Equipos a incluir ({selectedEquipos.length}):</p>
        <ListGroup>
          {selectedEquipos.map(eq => (
            <ListGroup.Item key={eq._id}>
              <div><strong>{eq?.equipo?.item?.nombre}</strong> — <small className="text-muted">{eq?.equipo?.cliente?.nombre}</small></div>
              <div className="small text-muted">Consecutivo: {eq?.consecutivo} • Puntos: {eq?.equipo?.item?.puntos ?? eq?.equipo?.puntos ?? 'N/A'}</div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={creating}>Cancelar</Button>
        <Button variant="primary" onClick={handleCreate} disabled={creating}>
          {creating ? (<><Spinner animation="border" size="sm" /> Creando...</>) : 'Confirmar y crear lote (pendiente)'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LoteCreateModal;
